const BASE_TEMPLATE_NAME = 'base';
const FAN_TEMPLATE_NAME = 'fan';

const LAYOUT_TEMPLATES = {
  fan: {
    name: FAN_TEMPLATE_NAME,
    elements: [
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'small' },
      { type: 'dial', size: 'small' },
      { type: 'dial', size: 'small' },
      { type: 'text-value' },
      { type: 'text' },
      { type: 'text-value' },
      { type: 'text-value' },
      { type: 'bar', orientation: 'vertical' },
      { type: 'bar', orientation: 'vertical' },
    ],
    groups: [
      { limit: 2, start: 0 },
      { limit: 3, start: 2 },
      { limit: 3, start: 5 },
      { limit: 1, start: 8 },
      { limit: 2, start: 9 },
    ],
  },
  base: {
    name: BASE_TEMPLATE_NAME,
    elements: [
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'medium' },
      { type: 'dial', size: 'small' },
      { type: 'dial', size: 'small' },
      { type: 'dial', size: 'small' },
      { type: 'bar', orientation: 'vertical' },
      { type: 'bar', orientation: 'vertical' },
      { type: 'bar', orientation: 'vertical' },
      { type: 'bar', orientation: 'vertical' },
    ],
    groups: [
      { limit: 4, start: 0 },
      { limit: 3, start: 4 },
      { limit: 4, start: 7 },
    ],
  },
};

const TEMPLATE_MAP = {
  power: 'base',
  pump: 'base',
  fan: 'fan',
  chiller: 'fan',
  pump_m7: 'base',
};

const mergeTemplateElement = (template, elements) =>
  template.map((value, index) => ({ ...template[index], ...elements[index] }));

class LayoutsController {
  constructor() {
    this.layoutTemplate = null;
  }

  $onInit() {}

  $onChanges(changes) {
    if (changes.series && this.template) {
      const layoutTemplateName = TEMPLATE_MAP[this.template];
      this.layoutTemplate = LAYOUT_TEMPLATES[layoutTemplateName];
      this.layoutTemplate.elements = [
        ...mergeTemplateElement(this.layoutTemplate.elements, this.series),
      ];
      this.layoutTemplate.off = this.off;
    }
  }
}

export default {
  template: require('./layouts.html'),
  controller: LayoutsController,
  bindings: {
    id: '<',
    template: '<',
    series: '<',
    off: '<',
  },
  controllerAs: 'vm',
};
